import { z } from 'zod';

import { transformKeysToCamelCase } from 'utils/formatters/transform-snake-to-camel';

export const OrdersHistoryResponseSchema = z
  .object({
    data: z.array(
      z.object({
        date: z.number(),
        order_number: z.number(),
        order: z.string(),
        total: z.number(),
        invoice_file: z.string().nullable(),
      }),
    ),
  })
  .transform((data) => transformKeysToCamelCase(data));

export type TOrdersHistoryDataResponse = z.infer<typeof OrdersHistoryResponseSchema>;
export type TOrdersHistoryData = TOrdersHistoryDataResponse['data'];
